import React from 'react'

import BookSuggestionsCarousel from '@components/BookSuggestionCarousel'

import useTranslateMessage from '@hooks/useTranslateMessage'
import { Container } from './SuggestionsSection.styles'

interface SuggestionSectionProps {
  bookId: number
  mightLikeRef: React.RefObject<HTMLDivElement>
}

export const SuggestionsSection = ({ bookId, mightLikeRef }: SuggestionSectionProps) => {
  const { t } = useTranslateMessage()

  return (
    <Container>
      <BookSuggestionsCarousel title={t({ id: 'bdp.mightLike' })} bookId={bookId} navigationRef={mightLikeRef} />
    </Container>
  )
}
